import choose from '@src/static/images/icon/landing/choose.svg';
import hotCup from '@src/static/images/icon/landing/hot-cup.svg';
import location from '@src/static/images/icon/landing/location.svg';
import blurredBackground from '@src/static/images/landing/blurred-background.jpg';
import commercial from '@src/static/images/landing/commercial.jpg';
import providerMobile from '@src/static/images/landing/cover-mobile.jpg';
import carBattery from '@src/static/images/landing/cover-optimized-shade.jpg';
import cover from '@src/static/images/landing/map.jpg';
import affirmDark from '@src/static/images/logos/affirm-dark.png';
import videoThumbnail from '@src/static/images/video-thumbnail.png';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect } from 'react';
import { useState } from 'react';
import WhyFeatures from './sections/WhyFeatures';

const Reviews = dynamic(import('@src/components/category/Reviews'));
const ContactModal = dynamic(import('@src/components/modals/ContactModal'));
const VideoModal = dynamic(import('@src/components/modals/VideoModal'));
const VideoModalCommercial = dynamic(import('@src/components/modals/VideoModalCommercial'));

function VehicleLandingPage({ phoneNumber, geolocation, myHref, asVar, googleNumber, CMSData, vehicleDescription }) {
	const [contactModalOpen, setcontactModalOpen] = useState(false);
	const [videoModalOpen, setvideoModalOpen] = useState(false);
	const [videoModalCommercial, setvideoModalCommercialOpen] = useState(false);
	const [size, setSize] = useState(0);

	useEffect(() => {
		// FIXME: window not accessible instantly on load (V.T. 11.2.2022)
		if (typeof window !== 'undefined') {
			setSize(window.innerWidth);
		}
	}, []);
	if (myHref.substring(0, 1) != '/') {
		myHref = '/' + myHref;
	}
	asVar = myHref;

	return (
		<div className="landing city">
			<ContactModal
				toPhoneNumber={phoneNumber}
				open={contactModalOpen}
				onCloseModal={() => setcontactModalOpen(false)}
			/>
			<VideoModal open={videoModalOpen} onCloseModal={() => setvideoModalOpen(false)} />
			<VideoModalCommercial open={videoModalCommercial} onCloseModal={() => setvideoModalCommercialOpen(false)} />

			<div 
				className="bg-[url('/images/tech-mobile.jpg')] lg:bg-none"
				style={{
					backgroundSize: '100% auto',
					backgroundPosition: 'top center',
					backgroundRepeat: 'no-repeat',
				}}
			>
				<div className="container mx-auto sm:pt-10 !mb-3 md:!mb-5 !pt-[200px] lg:!pt-[100px]">
					<div className="bg-white shadow-sm rounded-md relative overflow-hidden">
						<div
							className="lg:bg-[url(/images/tech.webp)]"
							style={{
								backgroundSize: '700px auto',
								backgroundPosition: 'top right',
								backgroundRepeat: 'no-repeat',
							}}>
							<div className="">
								<div className="!p-5 py-10 md:!p-10 md:!py-15 mx-w-[80%] lg:max-w-[50%]">
									<h1 className="text-3xl md:text-5xl tracking-tight text-[#0F2435] w-full !leading-[2.5rem] md:!leading-[3.5rem]">
										Mobile Car & Truck Battery Replacement Service in{' '}
										<span className="font-semibold">{`${
											geolocation && geolocation.formatted_address
												? geolocation.formatted_address
												: 'Your City'
										}`}</span>
										{vehicleDescription && (
											<>
												{' '}
												for your <span className="font-semibold ">{`${vehicleDescription}`}</span>
											</>
										)}
									</h1>

									<div className="md:inline-block !mt-3">
										<div className="flex items-center gap-4">
											<Link href={myHref} as={asVar}>
												<a className="w-[300px] max-w-[100%] bg-[#4c942f] mx-auto flex flex-1 items-center justify-center rounded-sm !py-4 !px-3 md:px-10 text-base text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 sm:full bg-brand-primary hover:bg-brand-primary/90 text-base font-semibold">
													SCHEDULE ONLINE <i className="far fa-arrow-right ml-2"></i>
												</a>
											</Link>
										</div>
									</div>

									<div className="!mt-4">
										<Reviews type="minimal" />
									</div>
								</div>
							</div>

							<div className="h-[2px] bg-gradient-to-r from-slate-300 to-transparent"></div>

							<div className="!p-5 md:!p-10" id="services">
								<WhyFeatures />
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				className="!mt-4"
				style={{
					backgroundImage: 'url(/images/happy-clients.jpg)',
					backgroundSize: '700px auto',
					backgroundPosition: 'top right',
					backgroundRepeat: 'no-repeat',
				}}
			>
				<div className="container bg-white/80 lg:bg-transparent">
					<Reviews href={myHref} type="static-v2" />
				</div>
			</div>

			<div className={`banner-with-sample-report align-middle`} id="how-it-works">
				<div className="inner">
					<div className="container">
						<div className="row">
							<div className="col-md-8 align-middle">
								<div className="text">
									<h3>How the Process Works</h3>
									<p>
										This is the easiest to use Battery platform in the world today, combining the
										best about DoorDash, Uber, and making the installation of batteries transparent
										and cheaper for you. From Prices to Delivery, we keep you informed and no hidden
										fees. If you have any questions we are always available. Please watch the 90
										second video for more info.
									</p>
								</div>
							</div>

							<div className="col">
								<div className="image mt-3" onClick={() => setvideoModalOpen(true)}>
									<div>
										<Image
											width="400px"
											height="229px"
											src={videoThumbnail}
											alt="Car Battery Installation Video"
											className="lazyload"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="steps">
				<div className="container">
					<div className="inner">
						<div className="row">
							<div className="col">
								<Link href={myHref} as={asVar} passHref>
									<div className="item">
										<span className="start-here">Start Here</span>
										<img src={location.src} alt="" className="lazyload" />

										<h4>Step 1</h4>
										<h6>Provide your Information</h6>
										<p>
											We will provide an immediate price quote based on your vehicle model and
											location.
										</p>
									</div>
								</Link>
							</div>

							<div className="col">
								<Link href={myHref} as={asVar} prefetch={false} passHref>
									<div className="item">
										<img src={choose.src} alt="" className="lazyload" />

										<h4>Step 2</h4>
										<h6>Select your Service Option</h6>
										<p>
											We offer <span>Pickup, Delivery and Installation</span> options.
										</p>
									</div>
								</Link>
							</div>

							<div className="col">
								<Link href={myHref} as={asVar} passHref>
									<div className="item no-affirm-disclaimer-border">
										<img src={hotCup.src} alt="" className="lazyload" />

										<h4>Step 3</h4>
										<h6>Place your order and we do the rest.</h6>
										<p>
											If you choose Delivery we’ll come to you. If you choose a Store our
											Technicians will be waiting for you.
										</p>
									</div>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="dynamic-content">
				<div className="container">
					<div className="row">
						<div className="col-md-8">
							<article>
								<p>
									Your car battery seems to run a little rough, with multiple starts needed or
									stalling throughout your drive. Or, you find your car won’t start at all — and
									you’re miles away from home.
								</p>

								<p>
									Making an appointment for car battery replacement services seems like the most
									logical solution. But, when you’re stranded, you need service now — no waiting, no
									calling for a friend to pick you up, and no coordinating with a towing company to
									get your vehicle to the closest auto shop.
								</p>

								<p>
									For the{' '}
									{`${
										geolocation && geolocation.formatted_address
											? geolocation.formatted_address
											: 'your'
									}`}{' '}
									area, 1-800-Battery provides fast mobile car battery replacement and install
									services. We build off our status as the largest batter marketplace in North America
									to offer just-in-time and precise car battery installation. When you need us, we’re
									there, accompanied by our wealth of knowledge.
								</p>

								<h2>
									Car Battery Delivery and Installation in{' '}
									<strong>{`${
										geolocation && geolocation.formatted_address
											? geolocation.formatted_address
											: 'Your Area'
									}`}</strong>
								</h2>
								<p>
									Yes, we offer car batteries for sale among our more than 10,000 products. But,
									1-800-Battery is more than just a retailer; we provide our customers with
									white-glove car and truck battery installation, too. What can we offer you, whether
									you need car battery replacement now or in the near future?
								</p>

								<ul>
									<li>
										<strong>We&apos;re cheaper than any dealership</strong>, and quicker, too.
										Instead of expensive towing and lengthy appointment times, we come to you with
										the correct battery for your vehicle. And, rather than tacking on extra fees, we
										roll the cost of installation into our single, transparent price.
									</li>
									<li>
										<strong>We’re home of the JumpStart Guarantee:</strong> Also unlike dealerships,
										we won’t pressure you to replace your car battery.Instead, unless testing shows
										it’s needed, we keep your existing battery in your car.
									</li>

									<li>
										<strong>We also offer a Correct Battery Guarantee:</strong> We carry{' '}
										<a href="https://1800battery.com/category/vehicle-batteries-car-or-truck/">
											car and truck batteries
										</a>{' '}
										by make and model. We’ll be prepared, no matter the notice, with the
										corresponding solution.
									</li>

									<li>
										<strong>Get service when you need it:</strong> Book an appointment online for
										immediate delivery and service, or schedule an appointment for a later date. For
										same-day work, we’ll drive out to your location — home, work parking lot or the
										side of the road in{' '}
										<span>{`${
											geolocation && geolocation.formatted_address
												? 'the ' + geolocation.formatted_address
												: 'your city'
										}`}</span>{' '}
										area - with the right car or truck battery from our expansive product selection.
									</li>

									<li>
										<strong>We prioritize service</strong> Along with rapid response, our
										professionals provide full car battery replacement service.We test the existing
										battery, can install a new unit, and then test it again to ensure everything’s
										working.We then recycle the old battery.
									</li>
								</ul>

								<p>
									Don’t wait around or go for weeks without a car.If you&apos;re in{' '}
									{`${
										geolocation && geolocation.formatted_address
											? geolocation.formatted_address
											: 'need'
									}`}{' '}
									and your car battery clearly needs replacement, get it done quickly and accurately
									with 1-800-Battery. Contact us today to set up an appointment.
								</p>
							</article>
						</div>

						<div className="col-md-4">
							<div className="landing-checklist in-sidebar mt-0">
								<div className="item odd">
									<i className="fas fa-check"></i>
									<span>Book Online for Immediate Delivery or Make Appointment</span>
								</div>

								<div className="item">
									<i className="fas fa-check"></i>
									<span>Installation Included in Price - No Hidden Charges!</span>
								</div>

								<div className="item odd">
									<i className="fas fa-check"></i>
									<span>Our JumpStart Guarantee!</span>
								</div>

								<div className="item ">
									<i className="fas fa-check"></i>
									<span>Professional Technicans with Real Time Tracking!</span>
								</div>

								<div className="item ">
									<i className="fas fa-check"></i>
									<span>
										Buy now, pay over time with{' '}
										<img
											src={affirmDark.src}
											alt="Car Battery Installation Video"
											className="lazyload"
										/>
									</span>
								</div>
							</div>

							<div className="search-form">
								<div className="action-buttons sidebar">
									<div className="inner">
										<Link href={myHref} as={asVar} passHref>
											<a className="btn book">
												GET STARTED <i className="far fa-arrow-right"></i>
											</a>
										</Link>
									</div>
								</div>

								<div className="mt-md-3 reviews-sidebar">
									<Reviews href={myHref} type="minimal" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="container">
				<div
					className="commercial"
					style={{
						background: `url(${blurredBackground.src}) center center`,
					}}>
					<div className="inner" onClick={() => setvideoModalCommercialOpen(true)}>
						<div className="tv">
							<div className="icon-container">
								<span>
									<i className="fas fa-play-circle"></i>
								</span>
							</div>
							<img src={commercial.src} alt="commercial" />
						</div>
						<p>Watch our commercial</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default VehicleLandingPage;
